import { InboxOutlined } from "@ant-design/icons";
import { Upload } from "antd";
import { Checkbox } from "antd";
import _ from "lodash";
import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import ReactPlayer from "react-player";
import { toast } from "react-toastify";
import styled from "styled-components";

import { ReactComponent as ICON_MEDIA_DELETE } from "@assets/svgs/ICON_MEDIA_DELETE.svg";
import { Button } from "@components/Button";
import ErrorValidate from "@components/ErrorValidate";
import { Icon } from "@components/Icon";
import { StyledInput } from "@components/Input";
import { Text } from "@components/Text";
import { COLOR_DARK, COLOR_GREEN, COLOR_WHITE } from "@static/COLORS";
import { generateDragProps } from "@utils/generateDragProps";
import { fetchAPI } from "@utils/https/fetchAPI";
import { VALIDATE_RULES } from "@validate/index";

const { Dragger } = Upload;

const FormContainer = styled.form`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 2px;
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  margin-bottom: 8px;
  background-color: rgba(0, 0, 0, 0.1);
`;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
  overflow: scroll;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
`;

const PreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const PreviewItem = styled.div`
  position: relative;
  width: 100%;
  height: 270px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SectionUpload = styled.div`
  height: 100%;
  margin-bottom: 10px;
`;

const SectionInput = styled.div`
  display: grid;
  gap: 20px;
  /* grid-template-columns: repeat(2, 1fr); */
`;

const ContainerClearButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 10px;
  top: 10px;
  padding: 4px;
  background: ${COLOR_DARK};
  border-radius: 4px;
`;
const { REACT_APP_API_ENDPOINT } = process.env;

export const FormEdit = ({
  setDataList = () => undefined,
  setIsModalVisible,
  // location_id,
  // customer_id,
  selectedData,
  setSelectedData,
}) => {
  const customer_id = _.get(selectedData, ["category_customer_id"]);
  const location_id = _.get(selectedData, ["location_id"]);
  const is_share = _.get(selectedData, ["is_share"]);
  const [isShare, setIsShare] = useState(is_share);
  const { control, handleSubmit, setValue } = useForm({
    defaultValues: {
      path: _.get(selectedData, ["path"]),
      display_name: _.get(selectedData, ["display_name"]),
      extension: _.get(selectedData, ["extension"]),
      duration: _.get(selectedData, ["duration"]),
      fileType: _.get(selectedData, ["type"]),
      fileSize: _.get(selectedData, ["size"]),
      fileKey: _.get(selectedData, ["fileKey"]),
    },
  });

  const [defaultPath, setDefaultPath] = useState(_.get(selectedData, ["path"]));
  const [fileUpload, setFileUpload] = useState(null);

  const onHandleSubmit = async (fileData) => {
    // const file = fileUpload;
    const display_name = _.get(fileData, ["display_name"]);
    const extension = _.get(fileData, ["extension"]);
    const type = _.get(fileData, ["fileType"]);
    const duration = _.get(fileData, ["duration"]);
    const size = _.get(fileData, ["fileSize"]);
    const fileKey = _.get(fileData, ["fileKey"]);
    const resp = await fetchAPI({
      method: "post",
      path: "/api/v1/medias-update",
      isAuth: true,
      data: {
        id: _.get(selectedData, ["id"]),
        category_customer_id: customer_id,
        location_id,
        display_name,
        duration,
        size,
        extension,
        type,
        file: fileUpload ? fileUpload : undefined,
        fileKey,
        previousPath: _.get(selectedData, ["path"]),
        is_share: isShare,
      },
    });

    if (_.get(resp, ["status"])) {
      const results = _.chain(resp).get(["result"]).value();
      toast.success("Upload Media Success.");
      setIsModalVisible((prev) => ({ ...prev, isOpen: false }));
      setDataList((prev) => {
        const resultShare = _.get(results, ["is_share"]) === "true";
        const updateDataList = _.map(prev, (item) => {
          return _.get(item, ["id"]) ===
            _.chain(results).get(["id"]).toInteger().value()
            ? { ...item, ...results, is_share: resultShare }
            : item;
        });
        return updateDataList;
      });
      setSelectedData(null);
    }
  };

  const onHandleClearFile = () => {
    setFileUpload(null);
    setDefaultPath(null);
  };

  return (
    <FormContainer onSubmit={handleSubmit(onHandleSubmit)} autoComplete="off">
      <Line />
      <InnerContainer>
        {!fileUpload && !defaultPath && (
          <SectionUpload>
            <Dragger {...generateDragProps({ setFileUpload, setValue })}>
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">
                Click or drag file to this area to upload
              </p>
            </Dragger>
          </SectionUpload>
        )}
        {(fileUpload || defaultPath) && (
          <PreviewContainer>
            <PreviewItem>
              {/* {fileUpload?.type?.startsWith("image/") ? ( */}
              {_.chain()
                .thru(() => {
                  return _.isNil(fileUpload)
                    ? _.get(selectedData, ["type"])
                    : _.get(fileUpload, ["type"]);
                })
                .startsWith("image/")
                .value() ? (
                <img
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                  src={
                    !defaultPath
                      ? URL.createObjectURL(fileUpload)
                      : `${REACT_APP_API_ENDPOINT}/${defaultPath}`
                  }
                  alt={_.get(fileUpload, ["name"], "-")}
                />
              ) : (
                <ReactPlayer
                  url={
                    !defaultPath
                      ? URL.createObjectURL(fileUpload)
                      : `${REACT_APP_API_ENDPOINT}/${defaultPath}`
                  }
                  controls
                />
              )}
              <ContainerClearButton onClick={() => onHandleClearFile()}>
                <Icon width={"24px"} height={"24px"} isCursor>
                  <ICON_MEDIA_DELETE fill={COLOR_WHITE} />
                </Icon>
              </ContainerClearButton>{" "}
            </PreviewItem>
            <SectionInput>
              <Controller
                name="display_name"
                control={control}
                rules={_.get(VALIDATE_RULES, ["required"])}
                render={({ field, fieldState: { error } }) => (
                  <div>
                    <Text
                      color={COLOR_DARK}
                      fontSize="14px"
                      style={{ marginBottom: 4, marginLeft: 4 }}
                    >
                      Name
                    </Text>
                    <StyledInput
                      label="name"
                      {...field}
                      size="large"
                      placeholder="name"
                    />
                    <ErrorValidate justify="start" error={error} />
                  </div>
                )}
              />
            </SectionInput>
          </PreviewContainer>
        )}
        <ButtonContainer>
          <Checkbox
            checked={isShare}
            onChange={() => setIsShare((prev) => !prev)}
          >
            Share
          </Checkbox>
          <Button
            type="submit"
            color={COLOR_GREEN}
            fontColor={COLOR_WHITE}
            fontSize="16px"
            padding="5px 20px"
          >
            Save
          </Button>
        </ButtonContainer>
      </InnerContainer>
    </FormContainer>
  );
};
